// extracted by mini-css-extract-plugin
module.exports = {"input_default":"styles_input_default__3x7Gx"};